import { default as book_45nowbFUGRF4uP0Meta } from "/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/book-now.vue?macro=true";
import { default as bookR706QMmSnYMeta } from "/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/book.vue?macro=true";
import { default as booking_45confirmationAuMdr05jMnMeta } from "/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/booking-confirmation.vue?macro=true";
import { default as _91uuid_93EIjSBWYxFYMeta } from "/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/booking/[uuid].vue?macro=true";
import { default as confirm_45cancellationInlrAEjdUmMeta } from "/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/confirm-cancellation.vue?macro=true";
import { default as confirmationzH9LXnZxQuMeta } from "/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/confirmation.vue?macro=true";
import { default as date_45timerT3Klxf5GiMeta } from "/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/date-time.vue?macro=true";
import { default as date5m1hNHUi1UMeta } from "/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/date.vue?macro=true";
import { default as _91uuid_939kjXUxKBZUMeta } from "/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/direct-booking/[uuid].vue?macro=true";
import { default as _91gym_93WeWxuUHrDgMeta } from "/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/enquiry-team/[gym].vue?macro=true";
import { default as _91uuid_932nq8RxOn1DMeta } from "/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/enquiry/[uuid].vue?macro=true";
import { default as existing_45booking6FINDe3YHvMeta } from "/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/existing-booking.vue?macro=true";
import { default as how_45did_45we_45do6tlTLwnUwrMeta } from "/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/how-did-we-do.vue?macro=true";
import { default as invalid7Fjxu8GyTNMeta } from "/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/invalid.vue?macro=true";
import { default as _91gym_93gOfhrdxYbMMeta } from "/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/location/[gym].vue?macro=true";
import { default as timeiPn1JcAOMnMeta } from "/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/time.vue?macro=true";
import { default as up_45staff_45internal_45useAd3o3jdtRWMeta } from "/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/up-staff-internal-use.vue?macro=true";
import { default as virtual_45confirmationyNchCTA4YCMeta } from "/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/virtual-confirmation.vue?macro=true";
import { default as virtual_45consultationLGf4FvNhhOMeta } from "/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/virtual-consultation.vue?macro=true";
import { default as _91gym_93BUziMylabrMeta } from "/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/walk-in/[gym].vue?macro=true";
export default [
  {
    name: book_45nowbFUGRF4uP0Meta?.name ?? "book-now",
    path: book_45nowbFUGRF4uP0Meta?.path ?? "/book-now",
    meta: book_45nowbFUGRF4uP0Meta || {},
    alias: book_45nowbFUGRF4uP0Meta?.alias || [],
    redirect: book_45nowbFUGRF4uP0Meta?.redirect || undefined,
    component: () => import("/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/book-now.vue").then(m => m.default || m)
  },
  {
    name: bookR706QMmSnYMeta?.name ?? "book",
    path: bookR706QMmSnYMeta?.path ?? "/book",
    meta: bookR706QMmSnYMeta || {},
    alias: bookR706QMmSnYMeta?.alias || [],
    redirect: bookR706QMmSnYMeta?.redirect || undefined,
    component: () => import("/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/book.vue").then(m => m.default || m)
  },
  {
    name: booking_45confirmationAuMdr05jMnMeta?.name ?? "booking-confirmation",
    path: booking_45confirmationAuMdr05jMnMeta?.path ?? "/booking-confirmation",
    meta: booking_45confirmationAuMdr05jMnMeta || {},
    alias: booking_45confirmationAuMdr05jMnMeta?.alias || [],
    redirect: booking_45confirmationAuMdr05jMnMeta?.redirect || undefined,
    component: () => import("/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/booking-confirmation.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93EIjSBWYxFYMeta?.name ?? "booking-uuid",
    path: _91uuid_93EIjSBWYxFYMeta?.path ?? "/booking/:uuid()",
    meta: _91uuid_93EIjSBWYxFYMeta || {},
    alias: _91uuid_93EIjSBWYxFYMeta?.alias || [],
    redirect: _91uuid_93EIjSBWYxFYMeta?.redirect || undefined,
    component: () => import("/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/booking/[uuid].vue").then(m => m.default || m)
  },
  {
    name: confirm_45cancellationInlrAEjdUmMeta?.name ?? "confirm-cancellation",
    path: confirm_45cancellationInlrAEjdUmMeta?.path ?? "/confirm-cancellation",
    meta: confirm_45cancellationInlrAEjdUmMeta || {},
    alias: confirm_45cancellationInlrAEjdUmMeta?.alias || [],
    redirect: confirm_45cancellationInlrAEjdUmMeta?.redirect || undefined,
    component: () => import("/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/confirm-cancellation.vue").then(m => m.default || m)
  },
  {
    name: confirmationzH9LXnZxQuMeta?.name ?? "confirmation",
    path: confirmationzH9LXnZxQuMeta?.path ?? "/confirmation",
    meta: confirmationzH9LXnZxQuMeta || {},
    alias: confirmationzH9LXnZxQuMeta?.alias || [],
    redirect: confirmationzH9LXnZxQuMeta?.redirect || undefined,
    component: () => import("/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/confirmation.vue").then(m => m.default || m)
  },
  {
    name: date_45timerT3Klxf5GiMeta?.name ?? "date-time",
    path: date_45timerT3Klxf5GiMeta?.path ?? "/date-time",
    meta: date_45timerT3Klxf5GiMeta || {},
    alias: date_45timerT3Klxf5GiMeta?.alias || [],
    redirect: date_45timerT3Klxf5GiMeta?.redirect || undefined,
    component: () => import("/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/date-time.vue").then(m => m.default || m)
  },
  {
    name: date5m1hNHUi1UMeta?.name ?? "date",
    path: date5m1hNHUi1UMeta?.path ?? "/date",
    meta: date5m1hNHUi1UMeta || {},
    alias: date5m1hNHUi1UMeta?.alias || [],
    redirect: date5m1hNHUi1UMeta?.redirect || undefined,
    component: () => import("/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/date.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_939kjXUxKBZUMeta?.name ?? "direct-booking-uuid",
    path: _91uuid_939kjXUxKBZUMeta?.path ?? "/direct-booking/:uuid()",
    meta: _91uuid_939kjXUxKBZUMeta || {},
    alias: _91uuid_939kjXUxKBZUMeta?.alias || [],
    redirect: _91uuid_939kjXUxKBZUMeta?.redirect || undefined,
    component: () => import("/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/direct-booking/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91gym_93WeWxuUHrDgMeta?.name ?? "enquiry-team-gym",
    path: _91gym_93WeWxuUHrDgMeta?.path ?? "/enquiry-team/:gym()",
    meta: _91gym_93WeWxuUHrDgMeta || {},
    alias: _91gym_93WeWxuUHrDgMeta?.alias || [],
    redirect: _91gym_93WeWxuUHrDgMeta?.redirect || undefined,
    component: () => import("/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/enquiry-team/[gym].vue").then(m => m.default || m)
  },
  {
    name: _91uuid_932nq8RxOn1DMeta?.name ?? "enquiry-uuid",
    path: _91uuid_932nq8RxOn1DMeta?.path ?? "/enquiry/:uuid()",
    meta: _91uuid_932nq8RxOn1DMeta || {},
    alias: _91uuid_932nq8RxOn1DMeta?.alias || [],
    redirect: _91uuid_932nq8RxOn1DMeta?.redirect || undefined,
    component: () => import("/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/enquiry/[uuid].vue").then(m => m.default || m)
  },
  {
    name: existing_45booking6FINDe3YHvMeta?.name ?? "existing-booking",
    path: existing_45booking6FINDe3YHvMeta?.path ?? "/existing-booking",
    meta: existing_45booking6FINDe3YHvMeta || {},
    alias: existing_45booking6FINDe3YHvMeta?.alias || [],
    redirect: existing_45booking6FINDe3YHvMeta?.redirect || undefined,
    component: () => import("/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/existing-booking.vue").then(m => m.default || m)
  },
  {
    name: how_45did_45we_45do6tlTLwnUwrMeta?.name ?? "how-did-we-do",
    path: how_45did_45we_45do6tlTLwnUwrMeta?.path ?? "/how-did-we-do",
    meta: how_45did_45we_45do6tlTLwnUwrMeta || {},
    alias: how_45did_45we_45do6tlTLwnUwrMeta?.alias || [],
    redirect: how_45did_45we_45do6tlTLwnUwrMeta?.redirect || undefined,
    component: () => import("/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/how-did-we-do.vue").then(m => m.default || m)
  },
  {
    name: invalid7Fjxu8GyTNMeta?.name ?? "invalid",
    path: invalid7Fjxu8GyTNMeta?.path ?? "/invalid",
    meta: invalid7Fjxu8GyTNMeta || {},
    alias: invalid7Fjxu8GyTNMeta?.alias || [],
    redirect: invalid7Fjxu8GyTNMeta?.redirect || undefined,
    component: () => import("/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/invalid.vue").then(m => m.default || m)
  },
  {
    name: _91gym_93gOfhrdxYbMMeta?.name ?? "location-gym",
    path: _91gym_93gOfhrdxYbMMeta?.path ?? "/location/:gym()",
    meta: _91gym_93gOfhrdxYbMMeta || {},
    alias: _91gym_93gOfhrdxYbMMeta?.alias || [],
    redirect: _91gym_93gOfhrdxYbMMeta?.redirect || undefined,
    component: () => import("/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/location/[gym].vue").then(m => m.default || m)
  },
  {
    name: timeiPn1JcAOMnMeta?.name ?? "time",
    path: timeiPn1JcAOMnMeta?.path ?? "/time",
    meta: timeiPn1JcAOMnMeta || {},
    alias: timeiPn1JcAOMnMeta?.alias || [],
    redirect: timeiPn1JcAOMnMeta?.redirect || undefined,
    component: () => import("/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/time.vue").then(m => m.default || m)
  },
  {
    name: up_45staff_45internal_45useAd3o3jdtRWMeta?.name ?? "up-staff-internal-use",
    path: up_45staff_45internal_45useAd3o3jdtRWMeta?.path ?? "/up-staff-internal-use",
    meta: up_45staff_45internal_45useAd3o3jdtRWMeta || {},
    alias: up_45staff_45internal_45useAd3o3jdtRWMeta?.alias || [],
    redirect: up_45staff_45internal_45useAd3o3jdtRWMeta?.redirect || undefined,
    component: () => import("/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/up-staff-internal-use.vue").then(m => m.default || m)
  },
  {
    name: virtual_45confirmationyNchCTA4YCMeta?.name ?? "virtual-confirmation",
    path: virtual_45confirmationyNchCTA4YCMeta?.path ?? "/virtual-confirmation",
    meta: virtual_45confirmationyNchCTA4YCMeta || {},
    alias: virtual_45confirmationyNchCTA4YCMeta?.alias || [],
    redirect: virtual_45confirmationyNchCTA4YCMeta?.redirect || undefined,
    component: () => import("/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/virtual-confirmation.vue").then(m => m.default || m)
  },
  {
    name: virtual_45consultationLGf4FvNhhOMeta?.name ?? "virtual-consultation",
    path: virtual_45consultationLGf4FvNhhOMeta?.path ?? "/virtual-consultation",
    meta: virtual_45consultationLGf4FvNhhOMeta || {},
    alias: virtual_45consultationLGf4FvNhhOMeta?.alias || [],
    redirect: virtual_45consultationLGf4FvNhhOMeta?.redirect || undefined,
    component: () => import("/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/virtual-consultation.vue").then(m => m.default || m)
  },
  {
    name: _91gym_93BUziMylabrMeta?.name ?? "walk-in-gym",
    path: _91gym_93BUziMylabrMeta?.path ?? "/walk-in/:gym()",
    meta: _91gym_93BUziMylabrMeta || {},
    alias: _91gym_93BUziMylabrMeta?.alias || [],
    redirect: _91gym_93BUziMylabrMeta?.redirect || undefined,
    component: () => import("/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/src/pages/walk-in/[gym].vue").then(m => m.default || m)
  }
]